import { Paperclip } from "lucide-react";

import { TooltipProvider } from "@/components/ui/tooltip";
import { ScrollArea } from "@/components/ui/scroll-area";
import PanelNavItem from "./PanelNavItem";

interface PanelNavigationProps {
  toggleSmartHistory: () => void;
  toggleAfterSales: () => void;
  toggleAttachments: () => void;
  hasAttachments?: boolean;
}

export default function PanelNavigation({
  toggleAttachments,
  hasAttachments = true,
}: PanelNavigationProps) {
  return (
    <TooltipProvider delayDuration={0}>
      <ScrollArea className="bg-black/3 border-l py-2">
        <div className="flex flex-col gap-2 h-full w-full">
          <div className="group flex flex-col gap-4 py-2 data-[collapsed=true]:py-2">
            <nav className="grid gap-1 px-2 group-[[data-collapsed=true]]:justify-center group-[[data-collapsed=true]]:px-2">
              {/*  <PanelNavItem
                active={false}
                title="Kundenhistorie"
                icon={History}
                onClick={() => toggleSmartHistory()}
              />
              <PanelNavItem
                active={false}
                title="Sales Assistent"
                icon={ChartNoAxesCombined}
                onClick={() => toggleAfterSales()}
              /> */}
              <PanelNavItem
                active={false}
                title="Anhänge"
                icon={Paperclip}
                onClick={() => toggleAttachments()}
                dimmed={!hasAttachments}
              />
            </nav>
          </div>
        </div>
      </ScrollArea>
    </TooltipProvider>
  );
}
